var staticStrUndefined = 'undefined'

module.exports = staticStrUndefined



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticStrUndefined.js
// module id = 59
// module chunks = 75